<div class="content-container">
	<section class="data-table payment all-lists">
		<settlements-header
			[allDepositsSum]="allDepositsSum"
			[userInfo]="userInfo"
		></settlements-header>

		<div class="data-table__wrap">

			<settlements-tab-header
				[settlementsCount]="settlementsCount"
				(changeTab)="switchTab($event)"
				(onSearch)="searchInvoices($event)"
				(filterByDate)="filterByDate($event)"
				(filterByAmount)="filterByAmount($event)"
				(filterByStatus)="filterByStatus($event)"
				[userInfo]="userInfo"
			></settlements-tab-header>

			<div >
				<teemapp-table
					[name]="'settlements-table'" 
					[tableSchema]="settlementsTable"
					[selectable]="false"
					[divClass]="'invoiceReceved'"
					(onLoad)="onLoadSettlements($event)"
					#settlementsTableRef
				></teemapp-table>
			</div>
			

		</div>
	</section>
</div>
